export interface Citizenship {
  type?: string;
  yearOfLanding?: number;
  isSponsored?: boolean;
  countryOfOrigin?: string;
  sponsorshipExpirationDate?: Date;
  yearOfPR?: number;
}
